import React, { useEffect, useState } from 'react';
import { TbTriangleFilled, TbTriangleInvertedFilled } from "react-icons/tb";
import Relatorio from '../Relatorio';


const DetailsModal = ({ closeDetailsModal, client, month, ano }) => {
    const [saidas, setSaidas] = useState([]);
    const [entradas, setEntradas] = useState([]);
    const [openRelatoriosTable, setOpenRelatoriosTable] = useState(false);

    useEffect(() => {
        const qtdSaidas = client.moves.filter(move => move.nome_anexo_atual?.toLowerCase() === "estoque").length;
        const qtdEntradas = client.moves.filter(move => move.nome_anexo_atual?.toLowerCase() !== "estoque").length;
        setSaidas(qtdSaidas);
        setEntradas(qtdEntradas);

    }, []);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-150 p-4" onClick={e => {
            if (e.target === e.currentTarget) closeDetailsModal();
        }}>
            {openRelatoriosTable && (<Relatorio closeModal={() => setOpenRelatoriosTable(false)} client={client} month={month} ano={ano} />)}
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-4xl w-full max-h-[85vh] overflow-hidden flex flex-col">
                <div className="relative bg-gradient-to-r from-vox-blue-600 to-vox-blue-800 px-6 py-6">
                    <div className="absolute top-4 right-4 z-10">
                        <button 
                            onClick={closeDetailsModal}
                            className="p-2 text-white hover:text-red-300 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-vox-blue-600 rounded-lg"
                        >
                            <span className="text-3xl">&times;</span>
                        </button>
                    </div>
                    <h2 className="text-2xl font-bold text-white">Detalhes do Cliente</h2>
                </div>
                <div className="flex-1 overflow-y-auto p-6">
                    <h2 className="text-2xl font-bold text-vox-blue-900 dark:text-white mb-4">{client.nome}</h2>
                    <button 
                        className="btn-vox-primary mb-6" 
                        onClick={() => setOpenRelatoriosTable(true)}
                    >
                        Relatório do Cliente
                    </button>
                    <div className="flex flex-wrap gap-6 justify-center mb-6">
                        <div className="bg-green-50 dark:bg-green-900/20 px-4 py-2 rounded-lg border border-green-200 dark:border-green-800">
                            <h3 className="text-lg font-semibold text-green-600 dark:text-green-400">
                                Entradas: {entradas}
                            </h3>
                        </div>
                        <div className="bg-red-50 dark:bg-red-900/20 px-4 py-2 rounded-lg border border-red-200 dark:border-red-800">
                            <h3 className="text-lg font-semibold text-red-600 dark:text-red-400">
                                Saídas: {saidas}
                            </h3>
                        </div>
                    </div>
                    <h3 className="m-0 mb-4 text-xl font-semibold text-vox-blue-900 dark:text-white border-b border-gray-200 dark:border-gray-700 pb-2">
                        Movimentações
                    </h3>

                    <div className="space-y-4 max-h-96 overflow-y-auto">
                        {
                            client.moves.map((move, index) => (
                                <div key={index} className='bg-white dark:bg-gray-800 rounded-xl p-4 border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow duration-200'>
                                    <div className='flex items-start gap-4'>
                                        <div className='flex-shrink-0 mt-1'>
                                            {
                                                move.nome_anexo_atual?.toLowerCase() === "estoque" ? (
                                                    <TbTriangleInvertedFilled className="text-red-500 text-3xl" />
                                                ) : (
                                                    <TbTriangleFilled className="text-green-500 text-3xl" />
                                                )
                                            }
                                        </div>
                                        <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                                            <div className="flex flex-col">
                                                <span className="font-semibold text-gray-700 dark:text-gray-300">Patrimônio:</span>
                                                <span className="text-gray-900 dark:text-white">{move.nEtiqueta}</span>
                                            </div>
                                            <div className="flex flex-col">
                                                <span className="font-semibold text-gray-700 dark:text-gray-300">Anexo Atual:</span>
                                                <span className="text-gray-900 dark:text-white">{move.nome_anexo_atual}</span>
                                            </div>
                                            {move.movimento_anterior && (
                                                <div className="flex flex-col">
                                                    <span className="font-semibold text-gray-700 dark:text-gray-300">Anexo Anterior:</span>
                                                    <span className="text-gray-900 dark:text-white">{move.movimento_anterior.nome_anexo_anterior}</span>
                                                </div>
                                            )}
                                            <div className="flex flex-col">
                                                <span className="font-semibold text-gray-700 dark:text-gray-300">Usuário:</span>
                                                <span className="text-gray-900 dark:text-white">{move.usuario}</span>
                                            </div>
                                            <div className="flex flex-col">
                                                <span className="font-semibold text-gray-700 dark:text-gray-300">Marca:</span>
                                                <span className="text-gray-900 dark:text-white">{move.marca}</span>
                                            </div>
                                            <div className="flex flex-col">
                                                <span className="font-semibold text-gray-700 dark:text-gray-300">Modelo:</span>
                                                <span className="text-gray-900 dark:text-white">{move.modelo}</span>
                                            </div>
                                            <div className="flex flex-col">
                                                <span className="font-semibold text-gray-700 dark:text-gray-300">Ramal:</span>
                                                <span className="text-gray-900 dark:text-white">{move.ramal}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                
                <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end">
                    <button
                        onClick={closeDetailsModal}
                        className="px-6 py-3 bg-gray-600 hover:bg-gray-700 text-white font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                    >
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DetailsModal;